import { Injectable } from '@angular/core';

@Injectable()
export class RetentionService {
  setAssetSort(sortField: string, sortOrder: number) {
    if(sessionStorage.getItem("assetRetention")){
      
      let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
      assetObj["sort"]={}
      assetObj["sort"]["field"] = sortField 
      assetObj["sort"]["order"] = sortOrder 
      sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))  
    }
    else{
      let assetObj = {"sort":{}}
      assetObj["sort"]["field"] = sortField
      assetObj["sort"]["order"] = sortOrder
      sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))
    }
  }
  getAssetSort(): any {
    if(sessionStorage.getItem("assetRetention") &&
    JSON.parse(sessionStorage.getItem("assetRetention"))["sort"]){
      let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
      assetObj["sort"]["order"] = Number(assetObj["sort"]["order"]) * (-1)
      return assetObj["sort"]
    }
    return null
  }
  setAssetSearch(assetSearchObj: {}) {
    if(sessionStorage.getItem("assetRetention")){
      
      let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
      assetObj["search"] = assetSearchObj 
      sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))  
    }
    else{
      let assetObj = {}
      assetObj["search"] = assetSearchObj
      sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))
    }
  }
  getAssetSearch(): any {
    if(sessionStorage.getItem("assetRetention") &&
    JSON.parse(sessionStorage.getItem("assetRetention"))["search"]){
      let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
      return assetObj["search"]
    }
    return {}
  }
  getAssetPagination(): number {
    if(sessionStorage.getItem("assetRetention") &&
    JSON.parse(sessionStorage.getItem("assetRetention"))["page"]){
      let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
      return assetObj["page"]
    }
    return 1;
  }
  setAssetPagination(currentPage: number) {
    if(sessionStorage.getItem("assetRetention")){
     let assetObj = JSON.parse(sessionStorage.getItem("assetRetention"))
     assetObj["page"] = currentPage 
     sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))  
   }
    else{
      let assetObj = {}
      assetObj["page"] = currentPage
      sessionStorage.setItem("assetRetention", JSON.stringify(assetObj))
    }
    
  }
  

  constructor() { }

  
}
